import styled from 'styled-components';
import { COLORS } from '@/theme';
import { Button } from '@/ui';

export const StyledTabTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid ${COLORS.GREY};
  padding: 1.5rem 2rem;
`;

export const StyledCreateButton = styled(Button)`
  &&& {
    max-width: 18rem;
    height: 2.75rem;

    svg {
      fill: ${COLORS.BLACK};
    }
  }
`;

export const StyledActionButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;
